<template>
    <div v-if="!state.loading">
    <div class="pgehd">
        <h2>Student List</h2>
        <div class="pgectr">
            <span class="pgebtn" @click="createnew">
                Add Student
            </span>
        </div>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>
        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="name" header="Name" />
        <PrimeColumn field="email" header="Email" />
        <PrimeColumn field="grade" header="Grade" />
        <PrimeColumn field="subjects" header="Subjects" />
        <PrimeColumn header="Options">
            <template #body="slotProps">
                <div class="flex gap-2">
                    <PrimeButton
                        label="Edit"
                        icon="pi pi-user-edit"
                        class="p-button-rounded p-button-text"
                        @click="edit(slotProps.data)"
                    />
                    <PrimeButton
                        label="Subjects"
                        icon="pi pi-bars"
                        class="p-button-rounded p-button-text"
                        @click="subjects(slotProps.data)"
                    />
                    <PrimeButton
                        label="Teachers"
                        icon="pi pi-users"
                        class="p-button-rounded p-button-text"
                        @click="teachers(slotProps.data)"
                    />
                </div>
            </template>
        </PrimeColumn>
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
  
    <ModalView
        :isVisible="state.createModal"
        :fixclose="true"
        @close="state.createModal = false">
        <DynamicForm :columns="2"
            :fields="createFields" @submit="addStudent"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView>
  
    <ModalView
        :isVisible="state.editModal"
        :fixclose="true"
        @close="state.editModal = false">
        <DynamicForm :columns="2" v-if="!state.modalLoading"
            :fields="editFields" @submit="updateStudent"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
        <div v-else class="loader">
            <img src="@/assets/img/ajldr.gif" />
        </div>
    </ModalView>
    
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref} from 'vue';
import ModalView from "@/components/ModalView.vue";
import DynamicForm from "@/components/DynamicForm.vue";
import { useRouter } from "vue-router";

export default {
    name:"StudentsView",
    components:{ModalView,DynamicForm},
    setup(){
        const list = ref([])
        const globalFilter=ref("")
        const subjects=ref([])
        const router = useRouter();
        const editFields=ref([])
        const state=reactive({loading:true,createModal:false,submitting:false,error:[],success:false,
            gender:[{label:"Male",value:"Male"},{label:"Female",value:"Female"}],editModal:false,modalLoading:false
        })
        function grade() {
            return Array.from({ length: 12 }, (_, i) => {
                const value = (i + 1).toString();
                return { label: "Grade "+value, value: value };
            });
        }
        const createFields=ref([
            { name: "Add Student", number: "1",data: 
                [
                    { type: 'text', name: 'name', label: 'Name',
                        value: ""  },
                    { type: 'password', name: 'pass', label: 'Password',
                        value: ""  },
                    { type: 'select', name: 'gender', label: 'Gender',
                        value: "",options:state.gender  },
                    {type: 'text', name: 'email', label: 'Email Address',
                        value: ""},
                    {type: 'select', name: 'grade', label: 'Grade',
                        value: "", options:grade()},
                    {type: 'date', name: 'birthday', label: 'Birthday',
                        value: ""},
                    { type: 'checkbox', name: 'subject', label: 'Subjects',
                        value:"",values:subjects },
                ]
            }
        ])
        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }
        

        function createnew(){
            state.createModal=true;
            state.submitting=false;
            state.success=false;
            state.errors=[];
        }

        function edit(row){
            state.editModal=true;
            state.submitting=false;
            state.modalLoading=true;
            state.success=false;
            state.errors=[];
            call({
                url:urls.students,
                data:{getStudentInfo:row.id},
                success:(res)=>{
                    if(res.status){
                        state.modalLoading=false
                        const data=res.msg;
                        const subs=data.subjects.split(",")
                        editFields.value=[
                            { name: "Edit Student", number: "1",data: 
                                [
                                    { type: 'text', name: 'name', label: 'Name',
                                        value: data.name },
                                    { type: 'password', name: 'pass', label: 'Password',
                                        value: ""  },
                                    { type: 'select', name: 'gender', label: 'Gender',
                                        value: data.gender,options:state.gender  },
                                    {type: 'text', name: 'email', label: 'Email Address',
                                        value: data.email},
                                    {type: 'select', name: 'grade', label: 'Grade',
                                        value: data.grade, options:grade()},
                                    {type: 'date', name: 'birthday', label: 'Birthday',
                                        value: data.birthdate},
                                    { type: 'checkbox', name: 'subject', label: 'Subjects',
                                        value:subs ,values:subjects },
                                    { type: 'hidden', name: 'id', value:row.id},
                                ]
                            }
                        ]
                    }else{
                        alert(res.msg);
                    }
                }
            })
        }
        onMounted(() => {
            call({
                url:urls.students,
                data:{getStudentsList:""},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        setTable(res.msg.list)
                        subjects.value=[];
                        Object.keys(res.msg.sub).forEach(k => {
                            subjects.value.push(res.msg.sub[k])
                        })
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function addStudent(data){
            state.submitting=true;
            state.errors=[];
            data.addStudent="";
            state.success=false;
            call({
                url:urls.students,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg)
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        function updateStudent(data){
            state.submitting=true;
            state.errors=[];
            data.addStudent="";
            state.success=false;
            call({
                url:urls.students,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg)
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        function teachers(row){
            router.push({ name: 'studentteachers', params: { id: row.id } });
        }
        return{state,globalFilter,list,createFields,createnew,addStudent,teachers,
            editFields,edit,updateStudent}
    }
}

</script>